import { getNoopAPI } from "../api/noop.js";
import { setFaroOnGlobalObject } from "./faroGlobalObject.js";
import { setInternalFaroOnGlobalObject } from "./internalFaroGlobalObject.js";
//#region src/sdk/registerFaro.ts
let faro = { api: getNoopAPI() };
function registerFaro(unpatchedConsole, internalLogger, config, metas, transports, api, instrumentations) {
	internalLogger.debug("Initializing Faro");
	faro = {
		api,
		config,
		instrumentations,
		internalLogger,
		metas,
		pause: transports.pause,
		transports,
		unpatchedConsole,
		unpause: transports.unpause
	};
	setInternalFaroOnGlobalObject(faro);
	setFaroOnGlobalObject(faro);
	return faro;
}
//#endregion
export { faro, registerFaro };

//# sourceMappingURL=registerFaro.js.map